import {
  AttributeDto,
  AttributeOperatorViewWithOperatorAttributeSettingsDto,
  OperatorAttributeDto,
} from '../../core/models/attribute-dto';
import { ErpDto } from '../../core/models/erp-dto';
import { OperatorDto } from '../../core/models/operator';
import { OrgUnitDto } from '../../core/models/org-unit-dto';
import { StockQuantityChangeReasonDto } from '../../core/models/stock-quantity-change-reason-dto';
import { UnitOfMeasureDto } from '../../core/models/unit-of-measure-dto';
import { UserDto } from '../../core/models/user-dto';
import { TreeNode } from '../../core/tree.utils';

export interface GeneralState {
  orgUnits: TreeNode<OrgUnitDto>;
  attributes: OperatorAttributeDto[];
  stockReductionReasons: StockQuantityChangeReasonDto[];
  operator: OperatorDto;
  operatorUsers: UserDto[];
  erps: ErpDto[];
  unitOfMeasure: UnitOfMeasureDto[];
  catalogueAttributes: AttributeDto[];
  operatorAttributePermission: AttributeOperatorViewWithOperatorAttributeSettingsDto[];
  currencies: string[];
  hasCaAccess: boolean;
  hasSmAccess: boolean;
  hasPlanAccess: boolean;
  hasPoolAccess: boolean;
  isUserManager: boolean;
  isOperatorMultiErp: boolean;
}

export const initialStoreState: Partial<GeneralState> = {
  attributes: [],
  operatorUsers: [],
  unitOfMeasure: [],
  currencies: [],
};
